document.addEventListener("DOMContentLoaded", function () {
	function redirectToSearch(query) {
		const keywords = (query || "").trim();
		const url = new URL("/search", window.location.origin);
		if (keywords) {
			url.searchParams.set("keywords", keywords);
		}
		window.location.href = url.toString();
	}

	function bindHeaderSearch(inputSelector, submitSelector) {
		const input = document.querySelector(inputSelector);
		const submit = document.querySelector(submitSelector);
		if (!input || !submit) {
			return;
		}

		const go = function () {
			redirectToSearch(input.value);
		};

		submit.addEventListener("click", function (event) {
			event.preventDefault();
			go();
		});

		input.addEventListener("keydown", function (event) {
			if (event.key === "Enter") {
				event.preventDefault();
				go();
			}
		});
	}

	bindHeaderSearch(".header-desktop-search-input", ".header-desktop-search-submit");
	bindHeaderSearch(".header-mobile-search-input", ".header-mobile-search-submit");

	const widget = document.querySelector(".site-search-widget");
	if (!widget) {
		return;
	}

	const form = widget.querySelector(".site-search-form");
	if (form) {
		form.addEventListener("submit", function (event) {
			event.preventDefault();

			const url = new URL(form.getAttribute("action") || window.location.pathname, window.location.origin);
			url.search = "";

			new FormData(form).forEach(function (value, key) {
				if (key === "cf-turnstile-response" || value == null) {
					return;
				}

				const text = String(value).trim();
				if (!text) {
					return;
				}

				if (key === "keywords") {
					url.searchParams.set(key, text);
					return;
				}

				url.searchParams.append(key, text);
			});

			url.searchParams.delete("Page");
			url.searchParams.delete("page");
			window.location.href = url.toString();
		});
	}

	const sortSelect = widget.querySelector("[data-site-search-sort]");

	function updateSearchParams(mutator) {
		const url = new URL(window.location.href);
		mutator(url.searchParams);
		url.searchParams.delete("Page");
		url.searchParams.delete("page");
		window.location.href = url.toString();
	}

	if (sortSelect) {
		sortSelect.addEventListener("change", function () {
			updateSearchParams(function (params) {
				const value = sortSelect.value || "standard";
				if (value === "standard") {
					params.delete("sort");
					params.delete("order");
					return;
				}

				const [sort, order] = value.split(":");
				params.set("sort", sort);
				params.set("order", order || "desc");
			});
		});
	}
});
